import { ColorType } from "../../Enums/ColorType"
import { DbImageData } from "../ImageData/DbImageData"
import { IConnectedSensor } from "./IConnectedSensor"

export class DbConnectedSensorBoolean implements IConnectedSensor{
  id!: string
  sensorId!: string
  sensorName!: string
  moduleName!: string

  showNotification: boolean = false;
  switchInputValue: boolean = false;
  visible: boolean = false;
  imageData!: DbImageData;

  reactionTimeForTrue!: number;
  reactionTimeForFalse!: number;

  messageByTrue!: string;
  messageByFalse!: string;

  colorForTrue!: ColorType;
  colorForFalse!: ColorType;

  public constructor(init?:Partial<DbConnectedSensorBoolean>) {
    Object.assign(this, init);
  }
}


